<template>
    <div>
        <div class="input-group input-group-lg">
            <!-- {{estado}} -->
            <select 
            class="custom-select" 
           
            v-model="estado.sigla"
            @change="valida()"
            v-bind:class="{'is-invalid' : estado.erro !== ''}"
            style="background-image: none !important; width: 218px; height: 42px; font-size: 15px"                                                                
            >
            <option v-for="(item) in estados" :value="item.sigla" :key="item.sigla">{{item.sigla}}</option>
            </select>
        </div>
        <div role="alert">
            <small class="form-text text-danger" v-show="estado.erro!== '' " >{{estado.erro}}</small>
        </div>
    </div>
</template>
<script>
// import Vuex from '@/vuex/store'
export default {
    props: ['estado'],
    data() {
        return {
            estados: [
                {
                    sigla: 'AC',
                    nome: 'ACRE'
                },                
                {
                    sigla: 'AL',
                    nome: 'ALAGOAS'
                },                
                {
                    sigla: 'AP',
                    nome: 'AMAPÁ'
                },                
                {
                    sigla: 'AM',
                    nome: 'AMAZONAS'
                },                
                {
                    sigla: 'BA',
                    nome: 'BAHIA'
                },                
                {
                    sigla: 'CE',
                    nome: 'CEARÁ'
                },                
                {
                    sigla: 'DF',
                    nome: 'DISTRITO FEDERAL'
                },                
                {
                    sigla: 'ES',
                    nome: 'ESPÍRITO SANTO'
                },                
                {
                    sigla: 'GO',
                    nome: 'GOIÁS'
                },                
                {
                    sigla: 'MA',
                    nome: 'MARANHÃO'
                },                
                {
                    sigla: 'MT',
                    nome: 'MATO GROSSO'
                },                
                {
                    sigla: 'MS',
                    nome: 'MATO GROSSO DO SUL'
                },                
                {
                    sigla: 'MG',
                    nome: 'MINAS GERAIS'
                },                
                {
                    sigla: 'PA',
                    nome: 'PARÁ'
                },                
                {
                    sigla: 'PB',
                    nome: 'PARAÍBA'
                },                
                {
                    sigla: 'PR',
                    nome: 'PARANÁ'
                },                
                {
                    sigla: 'PE',
                    nome: 'PERNAMBUCO'
                },                
                {
                    sigla: 'PI',
                    nome: 'PIAUÍ'
                },                
                {
                    sigla: 'RJ',
                    nome: 'RIO DE JANEIRO'
                },                
                {
                    sigla: 'RN',
                    nome: 'RIO GRANDE DO NORTE'
                },                
                {
                    sigla: 'RS',
                    nome: 'RIO GRANDE DO SUL'
                },                
                {
                    sigla: 'RO',
                    nome: 'RONDÔNIA'
                },                
                {
                    sigla: 'RR',
                    nome: 'RORAIMA'
                },                
                {
                    sigla: 'SC',
                    nome: 'SANTA CATARINA'
                },                
                {
                    sigla: 'SP',
                    nome: 'SÃO PAULO'
                },                
                {
                    sigla: 'SE',
                    nome: 'SERGIPE'
                },                
                {
                    sigla: 'TO',
                    nome: 'TOCANTINS'
                }
            ]
        }
    },
    methods: {
        valida(){
            if(this.estado.sigla === ''){
                this.estado.erro = 'Campo obrigatório'
            } else {
                this.estado.erro = ''
            }
        }
    }
}
</script>
